var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.729 18.75h-8.1a1.35 1.35 0 0 1-1.35-1.35v-4.95a1.35 1.35 0 0 1 1.35-1.35h8.1a1.35 1.35 0 0 1 1.35 1.35v4.95a1.35 1.35 0 0 1-1.35 1.35ZM8.629 12a.45.45 0 0 0-.45.45v4.95a.45.45 0 0 0 .45.45h8.1a.45.45 0 0 0 .45-.45v-4.95a.45.45 0 0 0-.45-.45h-8.1Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.279 12h-7.2a.45.45 0 0 1-.45-.45v-2.7a3.6 3.6 0 0 1 3.6-3.6h.9a3.6 3.6 0 0 1 3.6 3.6v2.7a.45.45 0 0 1-.45.45Zm-6.75-.9h6.3V8.85a2.7 2.7 0 0 0-2.7-2.7h-.9a2.7 2.7 0 0 0-2.7 2.7v2.25Zm3.15 4.05a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.129 14.7h-.9v1.8h.9v-1.8Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
};
export default SvgLock;